export const artistSlice = set => ({
  artist: null,
  setArtist: artist => set({ artist }),
})
